import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../shadcn/Select";

const PageSize = ({ value, onChange }) => (
  <Select value={String(value)} onValueChange={onChange}>
    <SelectTrigger>
      <SelectValue placeholder="Per Page">
        {value ? `Per Page ${value}` : "Per Page"}
      </SelectValue>
    </SelectTrigger>
    <SelectContent>
      <SelectItem value="25">25</SelectItem>
      <SelectItem value="50">50</SelectItem>
      <SelectItem value="100">100</SelectItem>
    </SelectContent>
  </Select>
);

export default PageSize;